/**
 * YouTube / deferred video player with center play button.
 */
class PeeSafeVideoPlayer extends HTMLElement {
  #played = false;
  #playButton = null;
  #player = null;
  #controls = null;
  #youtubeId = '';
  #autoplay = false;

  connectedCallback() {
    this.#playButton = this.querySelector('[data-ps-video-play]');
    this.#player = this.querySelector('[data-ps-video-player]');
    this.#controls = this.querySelector('[data-ps-video-controls]');
    this.#youtubeId = this.dataset.youtubeId || '';
    this.#autoplay = this.dataset.autoplay === 'true';

    this.#setupThumbnailFallback();

    if (!this.#youtubeId) return;

    this.#playButton?.addEventListener('click', () => this.#play());

    if (this.#autoplay) {
      this.#play();
    }
  }

  #setupThumbnailFallback() {
    const thumb = this.querySelector('.ps-video__poster--youtube');
    if (!thumb || !thumb.dataset.psVideoThumbFallback) return;

    thumb.addEventListener('error', () => {
      if (thumb.dataset.fallbackApplied === 'true') return;
      thumb.dataset.fallbackApplied = 'true';
      thumb.src = thumb.dataset.psVideoThumbFallback;
    }, { once: true });
  }

  #play() {
    if (this.#played || !this.#youtubeId || !this.#player) return;

    this.#played = true;

    const params = new URLSearchParams({
      autoplay: '1',
      rel: '0',
      modestbranding: '1',
      playsinline: '1',
    });

    if (this.#autoplay) {
      params.set('mute', '1');
    }

    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube.com/embed/${this.#youtubeId}?${params.toString()}`;
    iframe.title = this.dataset.videoTitle || 'Video';
    iframe.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.className = 'ps-video__iframe';

    this.#player.replaceChildren(iframe);
    this.#player.removeAttribute('hidden');

    this.querySelectorAll('[data-ps-video-poster]').forEach((el) => {
      el.setAttribute('hidden', '');
    });
    this.#controls?.setAttribute('hidden', '');
    this.classList.add('is-playing');
  }
}

if (!customElements.get('pee-safe-video-player')) {
  customElements.define('pee-safe-video-player', PeeSafeVideoPlayer);
}
